// extracted by mini-css-extract-plugin
export default {"root":"MechanicSlider_root__Kf7nx","track":"MechanicSlider_track__WBvmd","range":"MechanicSlider_range__8nY53","thumb":"MechanicSlider_thumb__J8JFb"};